import { Injectable } from "@angular/core";

@Injectable()
export class StorageManagerService {
	getSessionItem = (key: string, defaultValue?: any): any =>
		this.hasSessionItem(key)
			? JSON.parse(decodeURIComponent(atob(sessionStorage.getItem(key))))
			: defaultValue;

	hasSessionItem(key: string): boolean {
		const item = sessionStorage.getItem(key);
		return item !== undefined && item !== null;
	}

	setSessionItem(key: string, value: any): void {
		if (value != null) {
			sessionStorage.setItem(
				key,
				btoa(encodeURIComponent(JSON.stringify(value)))
			);
		}
	}

	removeSessionItem(key: string): void {
		sessionStorage.removeItem(key);
	}

	clearSession(): void {
		sessionStorage.clear();
	}

	getItem(key: string, defaultValue: any): any {
		return this.hasItem(key) ?
			JSON.parse(decodeURIComponent(atob(localStorage.getItem(key)))) :
			defaultValue;
	}

	hasItem(key: string): boolean {
		const item = localStorage.getItem(key);
		return item !== undefined && item !== null;
	}

	setItem(key: string, value: any): void {
		if (value != null) {
			localStorage.setItem(
				key,
				btoa(encodeURIComponent(JSON.stringify(value)))
			);
		}
	}

	removeItem(key: string): void {
		localStorage.removeItem(key);
	}

	clear(): void {
		localStorage.clear();
	}
}